import { useState } from 'react'
import { useRemoteClientPost } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'

export const LoadRooms = () => {
  const { httpClientPost } = useRemoteClientPost()
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(false)

  const load = () => {
    const { getUnitId } = useLocalStorage()

    if (!loading) {
      console.debug({
        salaId: getUnitId()
      })
      setLoading(true)
      httpClientPost('/salas/filtro', {
        idUnidade: getUnitId()
      })
        .then(setData)
        .catch(CatchMessageError)
        .finally(() => setLoading(false))
    }
  }

  return {
    data,
    load
  }
}
